import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseVoteMessageProps {
  onError: () => void;
  onSuccess: () => void;
}

interface VoteMessageParams {
  conversationId: string;
  messageId: string;
  voteType: "upvote" | "downvote";
}

export const useVoteMessage = ({ onSuccess, onError }: UseVoteMessageProps) =>
  useMutation<unknown, unknown, VoteMessageParams>({
    mutationFn: async ({
      conversationId,
      messageId,
      voteType,
    }: VoteMessageParams) =>
      reactQueryPost(
        internalApi.helpWidget.voteMessage({
          conversationId,
          messageId,
        }),
        {
          vote_type: voteType,
        },
      ),
    onSuccess,
    onError,
  });
